export default "__VITE_ASSET__OFF63gPv__"